<template>
<main class="page-select-company py-5">
  <div class="container">
    <PageTitle class="mb-5">Aziende</PageTitle>
    <div class="row" v-if="$oauth2.me.companies && $oauth2.me.companies.length">
      <div class="col-lg-4 col-md-6 mb-4" v-for="(company, i) of $oauth2.me.companies" :key="i">
        <LawaCard :name="company.name" :avatar="company.logo">
        <h4 class="font-weight-bold truncated-text" :title="company.name">{{ company.name }}</h4>
        <template #footer>
          <router-link class="btn btn-primary btn-sm" :to="{ name: 'operative-company', params: { id: company.id } }">
            Visualizza
          </router-link>
        </template>
      </LawaCard>
      </div>
    </div>
    <template v-else>
      <AlertFeedback status="info" class="w-100">
        <h4 class="alert-heading">Nessuna azienda disponibile</h4>
        <p>Non sono presenti aziende disponibili...</p>
    </AlertFeedback>
    </template>
  </div>
</main>
</template>

<script>

export default {
  name: 'page-select-company',
  components: {
    PageTitle: () => import('../../../components/Layout/LayoutOperative/PageTitle'),
    LawaCard: () => import('../../../components/Layout/Card/LawaCard'),
    AlertFeedback: () => import('../../../../libs/Feedback/components/Alert'),
  },
};

</script>
